import readableName from './readableName.js';

export default {
  methods: {
    // dynamically fill tables that appear in side menu, with add/edit buttons as needed according to user's permissions
    getSideMenu(tables, roles) {
      const menu = [
        {
          header: true,
          title: "Ballotpedia API v4"
        },
        {
          title: "Home",
          icon: "fa fa-home",
          href: "/home"
        }
      ];
    
      // Tables
      const tablesMenu = {
        title: "Tables",
        icon: "fa fa-table",
        child: []
      };
    
      const subMenus = getEmptySubMenus();
      const tablesToSubmenu = getSideMenuOrganization();
    
      let menuType = null;
      let only_contacts = false;
      if(roles.length==1 && roles.includes('contact_information_contractor')){
        only_contacts = true;
      }
      tables.forEach(table => {
        menuType = tablesToSubmenu.get(table.name);
        if ((menuType && only_contacts==false) || (menuType &&  table.name != 'contact_information')) {
          addTableItemToSideMenu(table, subMenus[menuType]);
        }
      });
    
      // add submenus to side menu if they have tables to display
      for (let menuName in subMenus) {
        if (subMenus[menuName].child.length > 0) {
          tablesMenu.child.push(subMenus[menuName]);
        }
      }
    
      // add all tables to the menu
      menu.push(tablesMenu);

      // add more menu items depending on role and other local storage items

      // Admin Functions
      if (roles.includes('admin')) {
        menu.push(adminMenu);
      }

      // Ultralocal Workflow
      if (roles.includes('ultralocal_writer') || roles.includes('admin')){
        const ulMenu = {
          ...ultraLocalMenu,
          child: ultraLocalMenu.child.filter(item => {
            return !item.role || item.role.some(r => roles.includes(r));
          })
        }
        menu.push(ulMenu);
      }

      // Upload District Boundaries
      if (roles.includes('maps')) {
        menu.push(mapsMenu);
      }

      // Modify Data Sales Users
      if (roles.includes('data_sales')) {
        menu.push(dataSalesMenu);
      }

      // Settings
      const visibleSettingsMenu = {
        ...settingsMenu,
        child: settingsMenu.child.filter(item => {
          return !item.role || item.role.some(r => roles.includes(r));
        })
      }
      menu.push(visibleSettingsMenu);

      return menu;
    }
  }
}

const mapsMenu = {
  title: "Upload District Boundaries",
  icon: "fa fa-map-marker",
  child: [
    {
      href: "/admin/uploadDistrictBoundaries",
      title: "Upload District Boundaries"
    },
    {
      href: "/tables/district_boundaries",
      title: "Edit District Boundaries"
    },
    {
      href: "/admin/simplifyDistrictBoundaries",
      title: "Simplify District Boundaries"
    }
  ]
};

const dataSalesMenu = {
  title: "Modify Data Sales Users",
  icon: "fa fa-user",
  child: [
    {
      href: "/admin/modifyUser/data_sales_users",
      title: "Modify Data Sales Users"
    },
  ]
};
const ultraLocalMenu = {
  title: "Ultralocal Workflow",
  icon: "fa fa-street-view",
  child:[
    {
      href: "/file_upload",
      title: "Upload a File"
    },
    { 
      href: "/tables/ultralocal.ul_named_bfed_batches",
      title: "BFED Batches"
    },
    {
      href: "/ultralocal/ultralocal.ul_office_matching_selection",
      title: "Match UL Offices With Suggestions"
    },
    {
      href: "/ultralocal/ultralocal.ul_office_matching_dropdown",
      title: "Match UL Offices With Dropdown"
    },
    {
      href: "/ultralocal/ultralocal.ul_office_matching",
      title: "Match UL Offices By Offices Table Lookup"
    },
    {
      href: "/ultralocal/ultralocal.ul_offices_creation_workflow",
      title: "Create UL Offices With Districts Table Lookup"
    },
    {
      href:"/tables/ultralocal.ul_bfed_contests",
      title: "BFED Contest Error Processing"
    },
    {
      href:"/tables/ultralocal.ul_bfed_candidates",
      title: "BFED Candidate Error Processing"
    },
    { href:"/data_correction",
      title: "Data Correction Utilities",
      role: ["data_correction", "admin"]
    }
  ]
};
const adminMenu = {
  title: "Admin Functions",
  icon: "fa fa-user",
  child: [
    {
      href: "/admin/createUser",
      title: "Create User"
    },
    {
      href: "/admin/modifyUser/users",
      title: "Modify User"
    },
     {
      href: "/admin/modifyUser/data_sales_users",
      title: "Modify Data Sales Users"
    },
    {
      href: "/admin/uploadDistrictBoundaries",
      title: "Upload District Boundaries"
    },
    {
      href: "/tables/district_boundaries",
      title: "Edit District Boundaries"
    },
    {
      href: "/admin/simplifyDistrictBoundaries",
      title: "Simplify District Boundaries"
    }
  ]
};

const settingsMenu = {
  title: "Settings",
  icon: "fa fa-wrench",
  child: [
    {
      href: "/settings/changepassword",
      title: "Change Password",
      role: ["reader", "writer", "admin"]
    },
    {
      href: "/settings/history",
      title: "User Edit History",
      role: ["writer", "admin"]
    },
    {
      href: "/settings/recordhistory",
      title: "Record Edit History",
      role: ["writer", "admin"]
    },
    { href:"/data_correction",
      title: "Data Correction Utilities",
      role: ["data_correction", "admin"]
    },
    {
      href: "/file_upload",
      title: "Upload a File",
      role: ["writer", "admin"]
    },
    {
      href: "/settings/clearSchemaCache",
      title: "Clear Schema Cache"
    }
  ]
};

function getEmptySubMenus() {
  const names = ['Elections', 'Ballot Measures', 'Officeholders', 'People', 'Organizations', 'Other', 'Research', 'Workflows', 'Endorsement Portal', 'Constitutions', 'Greenhouses', 'Policy'];
  const subMenus = {};
  for (let name of names) {
    subMenus[name] = {
      title: name,
      icon: "fa fa-bars",
      child: []
    }
  }
  return subMenus;
}

// adds table name and add/edit subitems as needed to a certain side menu
function addTableItemToSideMenu(table, menu) {  
  try {
   const item = {
      title: readableName.methods.readableTableName(table),
      child: []
    };
    if (table.permissions.includes('SELECT') && !table.name.includes('workflow')) {
      item.child.push({
        title: 'Edit',
        href: `/tables/${table.name}`
      });
    }
    if (table.permissions.includes('INSERT') && !table.name.includes('submitted_photos_staging')) {
      item.child.push({
        title: 'Add',
        href: `/add/${table.name}`
      });
    }

    menu.child.push(item);
  } catch (e) {
    // do nothing if menu doesn't exist for table
  }
}

function getSideMenuOrganization() {
  return new Map([
    ['aur_components',                          'Other'],
    ['aur_work',                                'Other'],
    ['ballot_measure_arguments',                'Ballot Measures'],
    ['ballot_measure_committees',               'Ballot Measures'],
    ['ballot_measure_donors',                   'Ballot Measures'],
    ['ballot_measure_readability_scores',       'Ballot Measures'],
    ['ballot_measure_topics',                   'Ballot Measures'],
    ['ballot_measures',                         'Ballot Measures'],
    ['constitutions',                           'Constitutions'],
    ['constitutions_articles',                  'Constitutions'],
    ['constitutions_sections',                  'Constitutions'],
    ['constitutions_topics',                    'Constitutions'],
    ['constitutions_ballot_measures',           'Constitutions'],
    ['bt50_legislator_matching',                'Other'],
    ['bt50_staging',                            'Other'],
    ['candidate_cards',                         'Elections'],
    ['candidate_creation_workflow',             'Workflows'],
    ['candidate_endorsements_staging',          'Elections'],
    ['candidate_research_worksheet',            'Research'],
    ['candidates',                              'Elections'],
    ['candidate_stage_results',                 'Elections'],
    ['committee_membership',                    'Officeholders'],
    ['committees',                              'Officeholders'],
    ['covid_debates',                           'Other'],
    ['covid_policy_topics',                     'Other'],
    ['contact_information',                     'People'],
    ['daily_stats',                             'Other'],
    ['data_sales_queries',                      'Other'],
    ['disclaimers',                             'Elections'],
    ['election_dates',                          'Elections'],
    ['endorsements',                            'Elections'],
    ['endorser_profiles',                       'Elections'],
    ['ep.accounts' ,                            'Endorsement Portal'],
    ['ep.accounts_profiles',                    'Endorsement Portal'],
    ['ep.addresses',                            'Endorsement Portal'],
    ['ep.candidate_profiles' ,                  'Endorsement Portal'],
    ['ep.confirmation_statuses',                'Endorsement Portal'],
    ['ep.data_sources' ,                        'Endorsement Portal'],
    ['ep.endorser_profiles',                    'Endorsement Portal'],
    ['ep.interaction_statuses' ,                'Endorsement Portal'],
    ['ep.interaction_types',                    'Endorsement Portal'],
    ['ep.interactions' ,                        'Endorsement Portal'],
    ['ep.profile_categories' ,                  'Endorsement Portal'],
    ['ep.profile_contacts' ,                    'Endorsement Portal'],
    ['ep.profile_rankings' ,                    'Endorsement Portal'],
    ['ep.profile_types',                        'Endorsement Portal'],
    ['ep.profiles' ,                            'Endorsement Portal'],
    ['ep.profiles_quizzes' ,                    'Endorsement Portal'],
    ['ep.question_responses' ,                  'Endorsement Portal'],
    ['ep.questions',                            'Endorsement Portal'],
    ['ep.quiz_items' ,                          'Endorsement Portal'],
    ['ep.quizzes',                              'Endorsement Portal'],
    ['ep.topic_responses',                      'Endorsement Portal'],
    ['ep.topics' ,                              'Endorsement Portal'],
    ['error_tracking',                          'Other'],
    ['external_ids',                            'Other'],
    ['filing_periods',                          'Elections'],
    ['finance_contributions',                   'Elections'],
    ['finance_summary',                         'Elections'],
    ['greenhouse_officeholder_page_update',     'Greenhouses'],
    ['greenhouse_page_creation',                'Greenhouses'],
    ['historic_finance_summary',                'Other'],
    ['historic_district_donors',                'Other'],
    ['influencers',                             'Other'],
    ['issue_positions',                         'Elections'],
    ['leadership',                              'Officeholders'],
    ['leadership_positions',                    'Officeholders'],
    ['local_candidate_campaign_themes_research_worksheet', 'Research'],
    ['local_candidate_endorsements_research_worksheet',    'Research'],
    ['local_candidate_research_worksheet',      'Research'],
    ['local_officeholder_research_worksheet',   'Research'],
    ['nces_district_academic_performance',      'Other'],
    ['nces_district_enrollment',                'Other'],
    ['nces_district_fiscal_information',        'Other'],
    ['nces_district_staff',                     'Other'],
    ['nces_schools',                            'Other'],
    ['nces_state_enrollment',                   'Other'],
    ['office_groups',                           'Other'],
    ['officeholder_rules',                      'Other'],
    ['submitted_photos_staging',                'Elections'],
    ['officeholders',                           'Officeholders'],
    ['partisan_indicators',                     'Other'],
    ['party_affiliation_changes',               'Other'],
    ['party_control',                           'Other'],
    ['people',                                  'People'],
    ['people_photos',                           'People'],
    ['people_achievements',                     'People'],
    ['people_career',                           'People'],
    ['policy.arguments',                        'Policy'],
    ['policy.claims',                           'Policy'],
    ['policy.counter_arguments',                'Policy'],
    ['policy.counter_claims',                   'Policy'],
    ['policy.counter_theses',                   'Policy'],
    ['policy.evidence',                         'Policy'],
    ['policy.evidence_types',                   'Policy'],
    ['policy.parent_topics',                    'Policy'],
    ['policy.source_types',                     'Policy'],
    ['policy.theses',                           'Policy'],
    ['policy.topics',                           'Policy'],
    ['professions',                             'People'],
    ['officeholder_research_worksheet',         'Research'],
    ['offices',                                 'Officeholders'],
    ['organizations',                           'Organizations'],
    ['race_ratings',                            'Other'],
    ['races',                                   'Elections'],
    ['religions',                               'People'],
    ['salaries',                                'People'],
    ['stages',                                  'Elections'],
    ['state_legislation',                       'Other'],
    ['state_legislation_categories',            'Other'],
    ['state_legislative_sessions',              'Other'],
    ['survey_photos_staging',                   'Elections'],
    ['survey_questions',                        'Elections'],
    ['survey_responses',                        'Elections'],
    ['survey_staging',                          'Elections'],
    ['ultralocal.ul_bfed_contacts',             'Research'],
    ['vote_by_mail',                            'Elections'],
    ['vote_in_person',                          'Elections'],
    ['voting_rules',                            'Elections'],
    ['campaign_themes',                         'Elections']
  ]);
}
